'use client';

import React, { FC } from 'react';
import styles from './DemoBanner.module.scss';
import { ITheme } from '@/src/lib/types/themeInterface';
import { useInView } from 'react-intersection-observer';
import classNames from 'classnames';
import ShopifyStoreButton from '@/src/components/ui/shopifyButton/ShopifyStoreButton';

type TPage = {
  theme: ITheme;
};

const DemoBanner: FC<TPage> = ({ theme }) => {
  const { ref, inView } = useInView({
    initialInView: false,
    rootMargin: '-180px',
    triggerOnce: true,
  });

  return (
    <li
      className={classNames(styles.demoBanner, { [styles.demoBanner_bannerAnimate]: inView })}
      ref={ref}
      style={{ animationDelay: '0.5s' }}>
      <div className={styles.demoBanner__head}>
        <div className={styles.demoBanner__heading}>Lifetime Access</div>
        <h3 className={styles.demoBanner__title}>
          One-Time Payment, <br /> No More Monthly Fees
        </h3>
        <div className={styles.demoBanner__text}>
          Get five customizable presets, regular updates, and lifetime support with a single purchase. Everything you need in one package — no subscriptions, no hidden costs.
        </div>
        <div className={styles.demoBanner__buttons}>
          <ShopifyStoreButton isWhite={true} theme={theme} />
        </div>
      </div>
    </li>
  );
};

export default DemoBanner;
